module.exports = __webpack_public_path__ + "assets/img/bg.e1d8985b.png";